import { render, staticRenderFns } from "./ApprovalProcessAwait.vue?vue&type=template&id=6e17ec96&scoped=true"
import script from "./ApprovalProcessAwait.vue?vue&type=script&lang=js"
export * from "./ApprovalProcessAwait.vue?vue&type=script&lang=js"
import style0 from "./ApprovalProcessAwait.vue?vue&type=style&index=0&id=6e17ec96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e17ec96",
  null
  
)

export default component.exports